export default "__VITE_ASSET__a3c8e1f4__"